import { render } from "./List.vue?vue&type=template&id=37aa5300"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=37aa5300&lang=css"
script.render = render

export default script